<template>
    <section v-if="hasPermissions(['Options-Defalut-Project-Codes Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Here you can change the default project codes and frequency. Select a floor type and a daily task. Check or uncheck a task. Select a frequency. Click save task.
            </p>
        </div>

        <form @submit.prevent="form_submit()">
            <div class="bar-container">
                <div class="bar-container__search-bar">
                    <div class="row mb-0">
                        <div class="col-md-6 formdynamic__item__field">
                            <label class="modal-label" v-html="'Floor type:'"/>
                            <select required class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="form_data.floor_id" @change="project_task_query()">
                                <option value="" disabled v-html="'Floor type'"/>
                                <option v-for="(item, i) in array_options.floor_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                        <div class="col-md-6 formdynamic__item__field">
                            <label for="" class="modal-label" v-html="'Daily task:'"/>
                            <select required class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="form_data.task_id" @change="project_task_query()">
                                <option value="" disabled v-html="'Daily task'" />
                                <option v-for="(item, i) in array_options.task_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="bar-container__options" style="position: relative; min-height: 30px;">
                    <UploadOptions
                        v-if="hasPermissions(['Options-Defalut-Project-Codes Upload'])"
                        :ref="'file_excel'"
                        :empty_format_data="empty_format_data"
                        :excel_file_headers="excel_file_headers"
                        :file_name="'default_projec_codes_template_file'"
                        @data="upload($event)"
                        style="position: absolute; bottom: 0;"
                    />
                </div>
            </div>
            <v-card style="margin-top:10px;">
                <div class="table-responsive table-fix-head" :style="`max-height: 35rem`" v-if="project_tasks.length">        
                    <table class="table">
                        <thead>
                            <th slot="header" class="header-item-manual" scope="col" v-html="'Select'"/>
                            <th scope="col" class="header-item-manual" v-for="(header, i) in table_headers" :key="i">
                                {{header.text}}
                                <span style="margin-left:15px;" v-if="header.value != 'frequency_id'">
                                    <img :src="sortable ? `/assets/img/svg/sort-items-reverse.svg` : `/assets/img/svg/sort-items.svg`" class="iconHistory" style="width:15px;" alt="Sort Icon" @click="liveSorting(header.value)"/>
                                </span>
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in project_tasks" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`select${i}`" :type="'checkbox'" class="custom-control-input" v-model="item.checked"/>
                                        <label :for="`select${i}`" :class="'custom-control-label ml-2'"/>
                                    </span>
                                </td>
                                <td v-html="item.name"/>
                                <td v-html="item.description"/>
                                <td>
                                    <select class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="item.frequency_id" :id="`selectFreq${i}`">
                                        <option value="" disabled v-html="'Select frequency:'"/>
                                        <option v-for="(prop, j) in array_options.frequency_id" :key="j" :value="prop.id" v-html="prop.name"/>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                 <table v-if="project_tasks.length > 0" class="table table-md">
                    <tfoot>
                        <tr>
                            <th class="float-right border-0" scope="col">Total Items: {{items_counter}}</th>
                        </tr>
                    </tfoot>
                </table>
            </v-card>
            <div class="text-center text-md-right" v-if="hasPermissions(['Options-Defalut-Project-Codes Write'])">
                <button class="mx-md-0 modal__buttons__item" v-html="'Save select task'"/>
            </div>
        </form>  
        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
        /> 
        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import UploadSummary            from    '@/components/UploadSummary'
import WaitingModal             from    '@/components/WaitingModal'
import UnauthorizedComponent    from   '@/components/UnauthorizedComponent'
import UploadOptions            from    '@/components/UploadOptions'
import Resources                from    './resources'
import FormResources            from    './form_resources'
import localMethods             from    './local_methods'
import 'vuetify/dist/vuetify.min.css'
import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'DefaultProjectCode',

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        UploadOptions,
        UploadSummary
    },

    mixins: [
        localMethods,
    ],

    data() {
        return {
            notyf,
            axios,
            user:           this.get_user(),
            title_page:     'Default Project Codes',
            rest_api:       `default_project_codes`,
            form_data:      FormResources.form_data,
            table_headers:  Resources.table_headers,
            breadcrumb:     Resources.breadcrumb,
            empty_format_data: Resources.empty_format_data,
            excel_file_headers: Resources.excel_file_headers,
            excel_data: [],
            summary: [],
            items_counter:  0,
            project_tasks:  [],
            project_tasks_backup: [],
            sortable:       true,
            array_options:
            {
                floor_id:   [],
                task_id:    [],
            },
            name_file_summary: ''
        }
    },
    methods: 
    {
        liveSorting(header_value)
        {
            if(this.sortable)
            {
                this.project_tasks.sort((item, item2) => 
                {
                    if (item[header_value] > item2[header_value])
                    {
                      return 1
                    }
                    if (item[header_value] < item2[header_value])
                    {
                      return -1
                    }
                    return 0
                })
            }
            else
            {
                this.project_tasks.sort((item, item2) => 
                {
                    if (item2[header_value] > item[header_value])
                    {
                      return 1
                    }
                    if (item2[header_value] < item[header_value])
                    {
                      return -1
                    }
                    return 0
                })
            }
            this.sortable = !this.sortable
        },

        async upload(data)
        {
            this.name_file_summary = 'default_project_codes_failed_template_file'

            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                await this.project_task_query()

            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        }
    }
}
</script>